import pieGreen from '@images/home/pie-green.png'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'

interface Signature {
  Args: {
    reportingDashboardModels: unknown[]
    showPrimeReports: boolean
  }
}

export class ReportsMaths extends Component<Signature> {
  get pieGreenPng() {
    return pieGreen
  }

  <template>
    <HomeTile @themeKey={{themeKey "maths"}} @title={{t "pages.home.panels.reports.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.pieGreenPng}} alt={{t "pages.home.panels.reports.imageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.reports.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="reporting.ui-scope.maths.dashboard"
            @models={{@reportingDashboardModels}}
            @appearance={{ButtonAppearance.regular}}
            {{posthogEvent "Reporting" product="maths" page="dashboard"}}
          >
            {{t "products.ms"}}
            {{t "pages.home.panels.reports.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
        {{#if @showPrimeReports}}
          <div class="text-center">
            <UiButtonLinkTo
              @route="reporting.ui-scope.mathseeds-prime.dashboard-table"
              @models={{@reportingDashboardModels}}
              @appearance={{ButtonAppearance.regular}}
              {{posthogEvent "Reporting" product="mathseeds-prime" page="dashboard"}}
            >
              {{t "products.mathseeds-prime"}}
              {{t "pages.home.panels.reports.buttonLabel"}}
            </UiButtonLinkTo>
          </div>
        {{/if}}
      </div>
    </HomeTile>
  </template>
}

export default ReportsMaths
